import React from "react";
import MainLayout from "../nav/MainLayout";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from "@azure/msal-react";
import Login from "../auth/Login.jsx";
import FlowChart from "../PageLayout/Details/FlowChart.jsx";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(2, 0),
  ...theme.mixins.toolbar,
}));

export default function Details() {

  return (
    <>
      <AuthenticatedTemplate>
        <div id="homePage" style={{ overflow: "hidden", position: "relative" }}>
          <Box className="mainLayout" sx={{ display: "flex", overflow: "hidden" }}>
            <MainLayout />

            <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
              <DrawerHeader />
              <DrawerHeader style={{ minHeight: "0px", paddingTop: "3px" }} />

              <div id="mainHome" style={{ overflowY: "auto" }}>
                {/* <table id="detailsTable" width="100%">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Analysis Date</th>
                      <th>Vendor</th>
                      <th>Status</th>
                      <th width="5%" style={{textAlign:"center"}}>Action</th>

                    </tr>
                  </thead>
                  <tbody>
                    {data.map((item, index) => (
                      <tr key={index}>
                        <td>{item.Name}</td>
                        <td>{item["Analysis Date"]}</td>
                        <td>{item.Vendor}</td>
                        <td>{item.Status}</td>
                        <td style={{textAlign:"center"}}>
                            <Link to={`/dashboard?=${item.Vendor}`}>
                                <FaEye/>
                            </Link>
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table> */}

                <FlowChart/>
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
}
